<template>
  <div class="Ftim-box">
    <div class="Ftim-bt">
      <span>至德-</span>台海两岸
      <i></i>
    </div>

    <div class="">
      <div class="Ftim-top">
        <div class="Ftim-current">
          <em></em>当前位置：<span><router-link :to="{path:'/'}">首页</router-link> -- </span>台海两岸
        </div>
        
        <!-- <div class="Ftim-fanhui">
          <router-link to="/">
            <img src="../../../public/images/fanhui.png">
          </router-link>
        </div> -->
        
      </div>
    </div>

    <div class="Whole-tab">
      <span v-for="(item, index) in tablist" :class="avice == item.id?'on':''" :key="index" @click="Tab(item.id)">{{item.title}}</span>
    </div>

    <div class="Ftim-cent">
      
      <router-link :to="{path:'/straitinfo',query:{id:item.id,num:ishuoqu,tab:avice}}" class="Ftim-list" v-for="(item, index) in infolist" :key="index">
        <img :src="item.cover">
        <div class="Ftim-name">{{item.title}}</div>
        <div class="Ftim-time">{{item.created_at}}</div>
      </router-link>
    </div>

    <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
   
  </div>
</template>
<script>
export default {
  data() {
    return {
      tablist:[],
      avice:'',
      ishuoqu:'',
      infolist:[],
      page: 1,        //当前页码
      isgoto: false   //是否显示加载更多
    };
  },
  created(){
    this.getTab();
  },
  mounted() {
  },
  methods: {
    //获取台海两岸分类
    getTab(){
      this.$http.get('category/11').then((res)=>{
        if(res.data.code == 200){
          this.tablist = res.data.data;
          this.ishuoqu = res.data.data[0].id;
          if(this.$route.query.tab == undefined){
            this.avice = res.data.data[0].id;
            this.$router.push({
              path:'/strait',
              query:{
                tab: this.avice
              }
            })
          }else{
            this.avice = this.$route.query.tab;
          }
          this.getData();
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取列表数据
    getData(){
      this.$layer.loading();
      this.$http.get('article/2/'+this.avice+'?page='+this.page).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = this.infolist.concat(res.data.data.data);
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //切换
    Tab(id){
      if(this.avice != id){
        this.$router.push({
          path:'/strait',
          query:{
            tab:id
          }
        })
        this.avice = id;
        this.page = 1;
        this.$layer.loading();
        this.$http.get('article/2/'+this.avice+'?page='+this.page).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.infolist = res.data.data.data;
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
      }
    },

    //加载更多
    More(){
      this.getData();
    }
  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 60px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Ftim-top{
    width: 1240px;
    height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 20px 20px 0px 0px;
    margin: 74px auto 0;
  }
  .Ftim-current{
    line-height: 74px;
    font-size: 16px;
    color: #333;
  }
  .Ftim-current em{
    display: inline-block;
    width: 12px;
    height: 12px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 50%;
    margin: 0 10px 0 20px;
  }
  .Ftim-current span{
    color: #999;
  }
  .Ftim-current a{
    color: #999;
  }
  .Ftim-fanhui{
    width: 20px;
    height: 20px;
    margin-right: 30px;
  }
  .Whole-tab{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .Whole-tab span{
    padding: 0px 20px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    text-align: center;
    line-height: 36px;
    margin-right: 15px;
    cursor: pointer;
  }
  .Whole-tab span.on{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    color: #fff;
  }
  .Ftim-cent{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
  }
  .Ftim-list{
    width: 285px;
    display: block;
    margin-top: 30px;
    margin-right: 0;
  }
  .Ftim-list:not(:nth-child(4n)){
    margin-right: 20px;
  }
  .Ftim-list img{
    width: 285px;
    height: 207px;
    border-radius: 12px;
  }
  .Ftim-name{
    font-size: 18px;
    color: #333333;
    line-height: 28px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 5px;
  }
  .Ftim-time{
    font-size: 16px;
    color: #D8D8D8;
    margin-top: 10px;
  }
  .Ftim-more{
    width: 180px;
    height: 36px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
</style>